import React, { FC } from "react";
import { Typography, Card, Image } from "antd";
import styled from "styled-components";
// import Img3D from './Model3D'
import { fallBackImage } from "../utils/utilsFunctions";
import LinkComponent from "./LinkComponent";

const CardX = styled(Card)`
  font-family: 'Rogan';
  height: 100%;
  .ant-card-cover {
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
    .ant-image {
      height: 100%;
      text-align: center;
    }
  }
  .card-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
  }
`;

const Img = styled(Image)`
display: inline-block;
width: auto;
max-width: 100%;
height: 100%;
object-fit: contain;
/* max-inline-size: 100%;
block-size: auto;
aspect-ratio: 2/1;
object-fit: cover;   */
`

const MetaTitle = styled(Typography.Title)`
  &.ant-typography {
    font-size: 1.3rem;
  }
`;
const MetaSubTitle = styled(Typography.Title)`
  &.ant-typography {
    font-size: 16px;
    text-transform: capitalize;
  }
`;
// const MetaParagraph = styled(Typography.Paragraph)`
//   &.ant-typography {
//     font-size: 12px;
//   }
// `;
// const Img = styled.img`
//   display: inline-block;
//   align-self: center;
//   max-width: 100%;
// `;
interface DProps {
  design?: any;
}

const MyCard: FC<DProps> = ({ design }) => {
  return (
    <LinkComponent href={`/design/${design._id}`}>
      <CardX
        hoverable
        cover={
          <Img
            // style={{ padding: '10px' }}
            alt={design?.name}
            src={design.featuredImage || fallBackImage}
            fallback={fallBackImage}
            preview={false}
          />
        }
      >
        <div className="card-content">

          <MetaTitle>{design?.name || "Lorem Ipsum Dolor"}</MetaTitle>
          {/* <MetaParagraph>
          {design?.description ||
            "Lorem ipsum dolor sit amet, consect Lorem ipsum dolor sit amet, consect Lorem ipsum dolor sit amet, consectLorem ipsum dolor sit amet, consect"}
        </MetaParagraph> */}
          <MetaSubTitle>
            {design?.owner?.firstName
              ? `${design?.owner?.firstName} ${design?.owner?.lastName || ''}`
              : `${design?.owner?.firstName}`}
          </MetaSubTitle>

        </div>
      </CardX>
    </LinkComponent>
  );
};

export default MyCard;
